import { EpgUtil } from '../../utility/EpgUtil';
import { EpgApi } from '../../../api/EpgApi';
import { ErrorTranslationKeys } from '../../../api/models/TranslationKeys';
import { ProgramDetailDataSource } from './ProgramDetailDataSource';
import { EpgDetailDataSource } from './EpgDetailDataSource';
import { Backend } from '../../../api/Backend';
import { IDetailModel } from '../detail.types';

export class ChannelDetailDataSource extends EpgDetailDataSource {
  private programDS: ProgramDetailDataSource | undefined;
  constructor(backend: Backend) {
    super(backend);
  }

  override load(channelId: string): Promise<IDetailModel | undefined> {
    return this.initChannels().then(() => {
      this.channel = this.channelsList?.find(channel => channel.channelId === channelId);
      if (!this.channel) {
        return;
      }

      //todo check adult

      const fromuntil = EpgUtil.getTodayFromUntil();
      return EpgApi.scheduleForChannel(this.backend, channelId, fromuntil.from, fromuntil.until).then(result => {
        const schedule = EpgUtil.findCurrentSchedule(result.schedules);
        if (!schedule) {
          throw new Error(this.backend.translations.forKey(ErrorTranslationKeys.error_load_details));
        }

        //todo check adult
        this.programDS = new ProgramDetailDataSource(this.backend, schedule.id);
        return this.programDS.load(schedule.program);
      });
    });
  }
}
